/* ready */
$(function () {
  'use strict';

  /* スムーススクロール */
  $('a[href^="#"]').on('click', function () {
    // スピード（ミリ秒）
    var speed = 300;
    // アンカーの値取得
    var href = $(this).attr('href');
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を座標で取得
    var position;
    if ($(this).parent().hasClass('l-pagetop')) {
      position = target.offset().top;
    } else {
      position = target.offset().top - $('.l-header').outerHeight();
    }
    // アニメーション
    $('body,html').not(':animated').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  $('a[href^="/nazoweb/#Nazoweb2_start"]').on('click', function () {
    console.log('aaa')
    // スピード（ミリ秒）
    var speed = 300;
    // 移動先を取得
    var target = $("#Nazoweb2_start");
    // 移動先を座標で取得
    var position;
    if ($(this).parent().hasClass('l-pagetop')) {
      position = target.offset().top;
    } else {
      position = target.offset().top - $('.l-header').outerHeight();
    }
    // アニメーション
    $('body,html').not(':animated').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  var urlHash = location.hash;
  if (urlHash === "#Nazoweb2_start") {
    var speed = 300;
    // 移動先を取得
    var target = $("#Nazoweb2_start");
    // 移動先を座標で取得
    var position;
    if ($(this).parent().hasClass('l-pagetop')) {
      position = target.offset().top;
    } else {
      position = target.offset().top - $('.l-header').outerHeight();
    }
    // アニメーション
    $('body,html').not(':animated').animate({ scrollTop: position }, speed, 'swing');
  }

  /* ナビカレント */
  naviCurrent($('.l-gnavi__list > li'));

  /* SPナビ */
  $('.l-sp-gnavi__btn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.l-sp-gnavi__menu').stop().fadeToggle();
  });
});

/* scroll */
$(window).on('scroll', function () {
  // ページトップ
  let deviceWidth = window.innerWidth;
  const topBtn = $('.l-bouken');

  if ($(this).scrollTop() > 100) {
    topBtn.fadeIn();
  } else {
    topBtn.fadeOut();
  }

  let scrollHeight = $(document).height();
  let scrollPosition = $(window).height() + $(window).scrollTop();
  let footHeight = $('.l-footer').outerHeight();

  if (deviceWidth > 1024) {
    footHeight -= 95;
  } else {
    footHeight -= 133;
  }

  if (scrollHeight - scrollPosition <= footHeight) {
    topBtn.removeClass('is-fixed');
  } else {
    topBtn.addClass('is-fixed');
  }
});

/* scroll */
$(window).on('scroll', function () {
  // ページトップ
  let deviceWidth = window.innerWidth;
  const topBtn = $('.l-irai');

  if ($(this).scrollTop() > 100) {
    topBtn.fadeIn();
  } else {
    topBtn.fadeOut();
  }

  let scrollHeight = $(document).height();
  let scrollPosition = $(window).height() + $(window).scrollTop();
  let footHeight = $('.l-footer').outerHeight();

  if (deviceWidth > 1024) {
    footHeight -= 95;
  } else {
    footHeight -= 133;
  }

  if (scrollHeight - scrollPosition <= footHeight) {
    topBtn.removeClass('is-fixed');
  } else {
    topBtn.addClass('is-fixed');
  }
});

$(window).on('scroll', function () {
  // ページトップ
  let deviceWidth = window.innerWidth;
  const topBtn = $('.l-pagetop');

  if ($(this).scrollTop() > 100) {
    topBtn.fadeIn();
  } else {
    topBtn.fadeOut();
  }

  let scrollHeight = $(document).height();
  let scrollPosition = $(window).height() + $(window).scrollTop();
  let footHeight = $('.l-footer').outerHeight();

  if (deviceWidth > 1024) {
    footHeight -= 95;
  } else {
    footHeight -= 133;
  }

  if (scrollHeight - scrollPosition <= footHeight) {
    topBtn.removeClass('is-fixed');
  } else {
    topBtn.addClass('is-fixed');
  }
});

function naviCurrent(naviElm) {
  const currentUrl = location.pathname + location.hash;

  naviElm.each(function () {
    let link = $(this).children('a').attr('href');
    var matchLink = new RegExp('^' + link);

    if (link == currentUrl || currentUrl.match(matchLink)) {
      $(this).addClass('is-current');
    }
  });
}